<template>
  <figure
    ref="target"
    class="relative"
    :class="className"
  >
    <img
      v-if="!shouldLoad"
      :width="width"
      :height="height"
      src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      alt=""
      class="w-full"
    >

    <img
      v-if="shouldLoad"
      :src="loadingSrc"
      :alt="alt"
      :width="width"
      :height="height"
      class="image-base w-full"
      :class="{ 'opacity-0': mainImageLoaded }"
    >

    <img
      v-if="shouldLoad"
      :src="src"
      :alt="alt"
      :width="width"
      :height="height"
      class="main-image"
      :class="{ 'is-loaded': mainImageLoaded }"
      @load="onMainImageLoad"
    >

    <figcaption
      v-if="figcaption"
      class="figcaption"
    >
      {{ figcaption }}
    </figcaption>
  </figure>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useElementVisibility } from '@vueuse/core';

defineProps({
  src: {
    type: String,
    required: true,
  },
  loadingSrc: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  figcaption: {
    type: String,
    default: null,
  },
  width: {
    type: [String, Number],
    default: null,
  },
  height: {
    type: [String, Number],
    default: null,
  },
  className: {
    type: String,
    default: '',
  },
});

const target = ref(null);
const isVisible = useElementVisibility(target);
const shouldLoad = ref(false);
const mainImageLoaded = ref(false);

watch(isVisible, (visible) => {
  if (visible) {
    shouldLoad.value = true;
  }
}, { once: true });

const onMainImageLoad = () => {
  mainImageLoaded.value = true;
};
</script>

<style scoped>
.image-base {
  display: block;
  transition: opacity 0.5s ease-in-out;
}
.main-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.main-image.is-loaded {
  opacity: 1;
}

.figcaption {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-align: center;
  color: #4b5563;
}
</style>
